module.exports = __webpack_public_path__ + "img/3hr-08.2910e0d5.jpg";